import { IsDefined, IsString, Length } from 'class-validator';
import { ProspectDataDto } from '../../../prospects';

export class ValidateBulkImportDto {
    @IsDefined()
    @IsString()
    @Length(0, 10000)
    prospectsData: ProspectDataDto[];

    constructor(iValidateBulkImport: ValidateBulkImportDto) {
        this.prospectsData = iValidateBulkImport.prospectsData;
    }
}
